<script>
  import { signOut, onAuthStateChanged } from "firebase/auth";
  import { addUserToWorkshopCloud, auth } from "../scripts/firebase.js";
  import {
    pageToLoad,
    user,
    selectedWorkshopID,
    openWorkshops,
  } from "../scripts/stores.js";

  let nextPage = "thankYou";

  let workshop;
  // Note: intentionally keeping this non-reactive so if they get to the "pay" page, they're "locked in" with a seat. This could theoretically mean over-enrolling, but I don't imagine it'll be a problem.
  workshop = $openWorkshops[$selectedWorkshopID];

  // fill in details according to https://developer.paypal.com/docs/api/orders/v2/
  const renderButtons = () => {
    paypal
      .Buttons({
        // Sets up the transaction when a payment button is clicked
        createOrder: function (data, actions) {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  currency_code: "USD",
                  value: workshop.price,
                },
                description: workshop.title,
              },
            ],
          });
        },
        // Finalize the transaction after payer approval
        onApprove: function (data, actions) {
          return actions.order.capture().then(async function (orderData) {
            // Successful capture! For dev/demo purposes:
            console.log(
              "Capture result",
              orderData,
              JSON.stringify(orderData, null, 2)
            );
            var transaction = orderData.purchase_units[0].payments.captures[0];
            // can call transaction.status and transaction.id
            await addUserToWorkshopCloud({
              workshopID: $selectedWorkshopID,
              username: $user.displayName,
            });
            pageToLoad.set(nextPage);
          });
        },
      })
      .render("#paypal-button-container");
  };

  // monitorAuthState();
</script>

<main class="page">
  <!-- <meta name="viewport" content="width=device-width, initial-scale=1" /> -->
  <!-- Ensures optimal rendering on mobile devices -->
  <div id="paypal-button-container" />
  <!-- Sandbox URL (use for development): -->
  <script
    src="https://www.paypal.com/sdk/js?client-id=test&currency=USD"
    on:load={renderButtons}></script>
  <!-- Production URL: -->
  <!-- <script
    src="https://www.paypal.com/sdk/js?client-id=AfC45BrHpC8yANCn3QnkZDt6jaMWY7yfqVagDKObjMa7c7YQzcaPT3MDym46VdgiOVoauNYiYUbGEP3W&currency=USD"
    on:load={renderButtons}></script> -->
</main>

<style>
</style>
